import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const cashJourneyRoutes = [
  {
    id: 'cash-out',
    trackingName: 'Cash Out',
    path: 'dl/view/cash-out',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOut')).JourneyCashOut,
    }),
  },
  {
    id: 'cash-out-amount',
    trackingName: 'Cash Out Amount',
    path: 'dl/view/cash-out/:cents_amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashOutAmount')).JourneyCashOutAmount,
    }),
  },
  {
    id: 'add-cash',
    trackingName: 'Add Cash',
    path: 'dl/view/add-cash',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCash')).JourneyAddCash,
    }),
  },
  {
    id: 'add-cash-amount',
    trackingName: 'Add Cash Amount',
    path: 'dl/view/add-cash/:cents_amount',
    lazy: async () => ({
      Component: (await import('../components/JourneyAddCashAmount')).JourneyAddCashAmount,
    }),
  },
  {
    id: 'cash-view-balance',
    trackingName: 'Cash View Balance',
    path: 'dl/view/balance',
    loader: async ({ context }) => {
      context?.browserNavigate('/account/money')
    },
  },
  {
    id: 'direct-deposit-setup',
    trackingName: 'Direct Deposit Setup',
    path: 'dl/view/balance/direct-deposit-setup',
    loader: async () => {
      throw redirect(`/dl/flow/${FlowType.GET_DIRECT_DEPOSIT_FORM}`)
    },
  },
  {
    id: 'transfers-setup',
    trackingName: 'Transfers Setup',
    path: 'dl/view/balance/transfers-setup',
    loader: async () => {
      throw redirect(`/dl/flow/${FlowType.POSTBANK_RETRIEVE_BANKING_INFORMATION}`)
    },
  },
] as const satisfies JourneyRoute[]
